import React from 'react';
import { toast } from 'react-toastify';
import {Route, Redirect} from 'react-router-dom';
import {authService} from "./../services/authService";
import Menu from "./../components/shared/Menu";
import { ReactComponent as Logo } from './../assets/images/logo.svg';
import { ReactComponent as Spinner } from './../assets/images/spinner.svg';



export default class ProtectedRoute extends React.Component{
    constructor(props){
        super(props);
        this.state={
            isAuthenticated:false,
            isLoaded : false,
            isAllowed:true
        }
    }
     componentDidMount = async () => {
         try{
            this.setState({isAuthenticated: await authService.isAuthenticated()})
            if(this.state.isAuthenticated){
                this.setState({isAllowed: await authService.userHasPermission(this.props.permission)})
            }
            this.setState({isLoaded:true})
         }
         catch(error){
             debugger;
            toast.error(error.response.data.Message, {
                position: toast.POSITION.BOTTOM_CENTER
              });
              this.setState({isLoaded:true})

         }
       
    }
    render = () => {
        const Component = this.props.component;
        if(this.state.isAuthenticated && this.state.isAllowed && this.state.isLoaded){
               return   (
               <Route {...this.props.rest}> 
                 <Menu/>
                   <Component {...this.props} />
               </Route>
               )
           }
           
           else if( (!this.state.isAuthenticated || !this.state.isAllowed) && this.state.isLoaded){
            return( 
               <Route {...this.props.rest}> 

            <Redirect to={
                 {
                     pathname : "/login",
                     state : this.props.location
                 }

             }/>
               </Route>
            
             )
         }
         else{
             return(
                 <div className="login-component">
                     <div className="mx-auto my-auto">
                     <Logo className="pb-6" style={{width:"300px"}}/>
                     <Spinner />
                     </div>
                     
                 </div>
             )
         }
    }
}